import { t } from 'i18next';
import { IdSchema, UuidSchema } from './common';
import * as v from 'valibot';

export const PromoTypeSchema = v.picklist([ 'promo', 'event', 'audit', 'eventNoQr', 'eventNoQrSegmentationFirst' ]);
export const PromoActivityTypeSchema = v.picklist([ 'fullName', 'phone', 'checkbox', 'iqosPass' ]);
export const PromoActivityContactSubtypeSchema = v.picklist([ 'gdprApproval', 'marketingApproval' ]);

export const PromoActivityContactRequestSchema = v.object({
	uuid: UuidSchema,
	required: v.boolean(),
	title: v.string(),
	help: v.nullable(v.string()),
	type: PromoActivityTypeSchema,
	subtype: v.nullable(PromoActivityContactSubtypeSchema),
	consentExpiration: v.nullable(v.number()),
});

export const PromoFormSchema = v.pipe(
	v.object({
		title: v.pipe(v.string(), v.nonEmpty(t('Prosím nenechávejte toto pole prázdné.'))),
		description: v.nullable(v.string()),
		start: v.nullable(v.pipe(v.string(), v.isoDate(t('Prosím zadejte platné datum.')))),
		end: v.nullable(v.pipe(v.string(), v.isoDate(t('Prosím zadejte platné datum.')))),
		promoCategoryUuid: v.pipe(
			v.nullable(UuidSchema),
			v.check((value) => value !== null, t('Prosím nenechávejte toto pole prázdné.')),
		),
		type: PromoTypeSchema,
		activityContacts: v.objectWithRest({}, PromoActivityContactRequestSchema),
		maxPrimaryChecks: v.pipe(
			v.number(t('Prosím, zadejte platné nezáporné celé číslo.')),
			v.integer(t('Prosím, zadejte platné nezáporné celé číslo.')),
			v.minValue(0, t('Prosím, zadejte platné nezáporné celé číslo.')),
		),
		requiresAttendance: v.boolean(),
		requiresPhoto: v.boolean(),
		isExternal: v.boolean(),
		maxVouchers: v.nullable(v.pipe(
			v.number(t('Prosím, zadejte platné nezáporné celé číslo.')),
			v.integer(t('Prosím, zadejte platné nezáporné celé číslo.')),
			v.minValue(0, t('Prosím, zadejte platné nezáporné celé číslo.')),
		)),
	}),
	v.forward(
		v.partialCheck(
			[ [ 'start' ], [ 'end' ] ],
			({ start, end }) => start == null || end == null || start <= end,
			t('Konec musí být později než začátek.'),
		),
		[ 'end' ],
	),
);

export type PromoFormModel = v.InferInput<typeof PromoFormSchema>;

export const PromoEventTypeFormSchema = v.pipe(v.object({
	uuid: UuidSchema,
	eventTypeId: v.pipe(
		v.nullable(IdSchema),
		v.check((value) => value !== null, t('Prosím vyberte platnou hodnotu z seznamu.')),
	),
	active: v.boolean(),
	start: v.nullable(v.pipe(v.string(), v.isoTime())),
	end: v.nullable(v.pipe(v.string(), v.isoTime())),
}));

export type PromoEventTypeFormModel = v.InferInput<typeof PromoEventTypeFormSchema>;
